import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule } from '@angular/forms';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

export const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  // autoplay: {
  //   delay: 1,
  // },
  pagination: true,
  // pagination: {
  //   el: '.swiper-pagination',
  //   type: 'bullets',
  // },
  loop: true,
  slideToClickedSlide: true,
  navigation: {
    prevEl: '.prev',
    nextEl: '.next'
  },  
  keyboard: { enabled: true },
  direction: 'horizontal',
  spaceBetween: 10,
  slidesPerView: 2.5,
  // centeredSlides: true,
  breakpoints: {
    991: {
      slidesPerView: 1.8
    },
    767: {
      slidesPerView: 1.5
    },
    500: {
      slidesPerView: 1.2,
    }
  }
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SwiperModule,
    FormsModule
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
